<script>

import mModal from './modalDialog.vue'

export default {
  name: 'frequencyPage',
  props: {
    dataLevel: {
      type: Number
    }
  },
  components: {
    mModal
  },
  data () {
    return {
      imgQuestion: require('../assets/question.svg'),
      showModal: false,
      lossDesc: [
        {
          title: 'Normal',
          desc: 'You can easily perceive everyday conversations, environmental sounds, and soft noises. Protect hearing by avoiding prolonged exposure to loud noises.'
        },
        {
          title: 'Mild',
          desc: 'You may struggle with soft speech or subtle sounds in noisy environments. Regular hearing check-ups are recommended. Consider wearing hearing aids to improve the situation and delay hearing deterioration.'
        },
        {
          title: 'Moderate',
          desc: 'Daily conversations can be challenging for you, especially with background noise. You often need others to repeat or speak louder. Hearing aids shall be worn to improve the situation and delay hearing deterioration.'

        },
        {
          title: 'Moderate-Severe',
          desc: 'You find it increasingly difficult to follow conversations, particularly in noisy settings. Understanding speech without visual cues is challenging for you. Hearing aids are likely to significantly improve your hearing experience. Consulting an audiologist is advised to explore suitable solutions.'

        },
        {
          title: 'Severe',
          desc: "You have difficulty hearing normal-volume conversations without assistance. Loud sounds may seem muffled to you. It's strongly recommended you consult a hearing specialist about hearing aids or other solutions that could improve your hearing experience."
        },
        {
          title: 'Profound',
          desc: 'You experience significant difficulty perceiving sounds, even at high volumes. Consulting an audiologist about advanced hearing solutions is advised. With proper support and technology, you can maintain a high quality of life and strong community connections.'
        }
      ]
    }
  },
  methods: {
    showType () {
      this.showModal = true
    },
    // 接收子组件的传值,并更改父组件的数据
    setModal (data) {
      this.showModal = data
    }
  }
}
</script>

<template>
  <div class="flex-box">

   <span class="titleTextBox">
      {{ lossDesc[this.dataLevel].title }}
      <button @click='showType' style="background: transparent; border: none;">
        <img :src="imgQuestion" style="width: 24px; height: 24px; "/>
      </button>
    </span>
    <div class="textBox">
      {{ lossDesc[this.dataLevel].desc }}
    </div>
    <div class="titleTextBox">
      <m-modal :show="showModal" v-on:listenToChildEvent="setModal">
        <h3 slot="header">Hearing grade calculation</h3>
        <h slot="content">
          Many people have asymmetric hearing, meaning the better ear may often compensate for the other. According to
          WHO classification criteria for hearing loss, your hearing grade is defined by your better performing ear.
        </h>
      </m-modal>
    </div>
  </div>
</template>

<style scoped>

.flex-box {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  background: #f8f8f8;
  margin-top: 10px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.titleTextBox {
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  text-align: left;
  margin-left: 30px;
  margin-top: 10px;
}

.textBox {
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  color: #686868;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-right: 30px;
  margin-left: 30px;
  margin-top: 20px;
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .titleTextBox {
    font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    margin-left: 20px;
    margin-top: 10px;
  }

  .textBox {
    font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
    text-align: left;
    color: #686868;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-right: 20px;
    margin-left: 20px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/frequecyDsc.vue